import axios from 'axios';
import {API_END_POINT_COMPANIO_WORK} from "../utils/constants";

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL + API_END_POINT_COMPANIO_WORK,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
    }
});

api.interceptors.response.use(
    response => response,
    error => {
        // If the server returns an error
        if (error.response && error.response.data && error.response.data.message) {
            // Reject promise with the error message from server
            return Promise.reject(error.response.data.message);
        }
        // For unexpected errors (e.g., network issues)
        return Promise.reject(error.message);
    }
);

export default api;
